// extracted by mini-css-extract-plugin
module.exports = {"section":"_2jkYA","potm":"_16YG6"};